export enum CornerType {
    Clip = 'CLIP',
    FilletClip = 'FILLETCLIP',
    Notch = 'NOTCH',
    None = 'NONE',
}
